export const CONSENT_COOKIE_KEY = 'axoft_cookie_consent'
export const CONSENT_VERSION = 1

export const MASK_TECHNICAL = 1 // 001
export const MASK_ANALYTICS = 2 // 010
export const MASK_MARKETING = 4 // 100

export const DEFAULT_CONSENT = {
  version: CONSENT_VERSION,
  technical: true,
  analytics: false,
  marketing: false,
  decided: false,
}



// WEBPACK FOOTER //
// ./src/modules/shared/services/consent/constants.js